export default __webpack_public_path__ + "static/media/vertical-long-distance-dots.99a0646f.svg";